import React, { useState } from 'react'
import { Col, FlexboxGrid, Panel, Row, Table } from 'rsuite'
import InputForm from '../../components/forms/input/InputForm'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import { Controller, useForm } from 'react-hook-form'
import notification from '../../utils/notification'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { cloneDeep, isEmpty } from 'lodash-es'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { exportAssessmentReport, searchAssessmentReport } from '../../redux/actions/assessment'
import InputSelectForm from '../../components/forms/input/InputSelectForm'
import { downloadFile } from '../../utils/fileUtil'
import moment from 'moment'
import { DATE_FORMAT, DATE_TIME_FORMAT } from '../../constants/date'
import InputDateForm from '../../components/forms/input/InputDateForm'

export default function AssessmentReportEvaluationScoreWigets({ schema: _schema, type, ...props }) {
  const { Column, HeaderCell, Cell } = Table
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const [formSchema, setFormSchema] = useState(_schema)
  const [isRefash, setIsRefash] = useState(false)
  const [datas, setData] = useState(_schema?.form?.values || [])
  const [totalSize, setTotalSize] = useState(_schema?.form?.total || 0)
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState()
  const [searchData, setSearchData] = useState({})
  const [request, setRequest] = useState({
    pageNum: 1,
    pageSize: displayLength,
  })

  // console.log('formSchema', formSchema.form.total)

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  const handleSearch = async (req) => {
    setLoading(true)
    try {
      // console.log('req : ', req)

      const response = await searchAssessmentReport(req, type)

      // console.log('response ', response)

      if (response) {
        setData(response.values || [])
        setTotalSize(response.total || 0)

        onRefash()
      } else {
        setData([])
        setTotalSize(0)
        onRefash()
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setLoading(false)
  }

  const handleExport = async () => {
    setLoading(true)
    try {
      // console.log('req : ', req)

      const file = await exportAssessmentReport(request, type)

      if (file) {
        downloadFile(
          file,
          file.name || `${formSchema.header}_${moment().format(DATE_TIME_FORMAT)}.xlsx`
        )
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setLoading(false)
  }

  const onSubmit = (data) => {
    console.log('onSubmit:', data)

    // console.log('formSchema', formSchema.form.searchForm)

    // return

    let req = {
      pageNum: 1,
      pageSize: displayLength,
    }

    var parameters = []

    if (data) {
      parameters.push({
        key: formSchema?.form?.searchForm?.projectCode?.name,
        value: data?.projectCode,
      })
      // formSchema.form.searchForm?.forEach((e) => {
      //   if (!isEmpty(e.inputType)) {
      //     parameters.push({ key: e.name, value: data[e.name] })
      //   }
      // })
    }

    req['parameters'] = parameters

    console.log('req : ', req)

    setPage(1)
    setRequest(req)
    handleSearch(req)
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  const handleChangePage = (dataKey) => {
    // console.log('handleChangePage page', dataKey)

    setPage(dataKey)

    let req = cloneDeep(request)

    req['pageNum'] = dataKey

    setRequest(req)
    handleSearch(req)
  }

  const handleChangeLength = (dataKey) => {
    // console.log('handleChangeLength dataKey', dataKey)
    setPage(1)
    setDisplayLength(dataKey)

    let req = cloneDeep(request)
    req['pageNum'] = 1
    req['pageSize'] = dataKey

    setRequest(req)
    handleSearch(req)
  }

  const onChangeInput = (key, value) => {
    var data = cloneDeep(searchData)

    data[key] = value
    setSearchData(data)
  }

  const getProjectRowSpan = (arr, index) => {
    if (arr[index].projectCode === null) return 0

    let count = 1
    for (let i = index + 1; i < arr.length; i++) {
      if (arr[i].projectCode !== null) break
      count++
    }
    return count
  }

  const getSectionRowSpan = (arr, index) => {
    if (arr[index].sectionNo === null) return 0

    let count = 1
    for (let i = index + 1; i < arr.length; i++) {
      if (arr[i].sectionNo !== null) break
      count++
    }
    return count
  }

  return (
    <Panel
      bordered
      // key={data.id}
      style={{ marginBottom: 10, marginTop: 10 }}
      collapsible
      defaultExpanded
      header={formSchema.header}
    >
      <>
        <Panel bordered style={{ marginBottom: 10, marginTop: -10 }} header={'ค้นหา'}>
          <FlexboxGrid style={{ marginTop: -10 }}>
            {formSchema?.form?.searchForm && (
              <InputForm
                schema={formSchema?.form?.searchForm?.projectCode}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                // value={formSchema?.form?.searchForm?.projectCode.value}
                value={searchData[formSchema?.form?.searchForm?.projectCode.name]}
                onChange={(value) => {
                  onChangeInput(formSchema?.form?.searchForm?.projectCode.name, value)
                }}
              />
            )}
          </FlexboxGrid>
          <hr />
          <Row style={{ textAlign: 'right' }}>
            <Col lg={24} md={24} sm={24} xs={24}>
              <SaveButton
                children="คันหา"
                icon="search"
                //onClick={handleSubmit(onSubmit)}
                onClick={() => {
                  onSubmit(searchData)
                }}
                // disabled={loading}
              />

              <CancelButton
                children="ยกเลิก"
                onClick={() => {
                  setSearchData({})
                  onSubmit()
                }}
              />
            </Col>
          </Row>
        </Panel>
        <Row style={{ textAlign: 'right', marginBottom: 10 }}>
          <Col>
            <ViewButton
              icon="print"
              children="Exprot Excel"
              disabled={formSchema?.form?.values?.length < 1}
              onClick={handleExport}
            />
          </Col>
        </Row>
        <div style={{ marginBottom: 20 }}>
          <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
            {/* HEADER */}
            <tr style={{ backgroundColor: '#dfdcdc' }}>
              <th style={{ padding: 3, verticalAlign: 'top' }}>
                {formSchema?.form?.columns?.heder01}
              </th>
              <th style={{ padding: 3, verticalAlign: 'top' }}>
                {formSchema?.form?.columns?.heder02}
              </th>
              <th style={{ padding: 3, verticalAlign: 'top' }}>
                {formSchema?.form?.columns?.heder03}
              </th>
              <th style={{ padding: 3, verticalAlign: 'top' }}>
                {formSchema?.form?.columns?.heder04}
              </th>
              <th style={{ padding: 3, verticalAlign: 'top' }}>
                {formSchema?.form?.columns?.heder05}
              </th>
              <th style={{ padding: 3, verticalAlign: 'top' }}>
                {formSchema?.form?.columns?.heder06}
              </th>
              <th style={{ padding: 3, verticalAlign: 'top' }}>
                {formSchema?.form?.columns?.heder07}
              </th>
              <th style={{ padding: 3, verticalAlign: 'top' }}>
                {formSchema?.form?.columns?.heder08}
              </th>
              <th style={{ padding: 3, verticalAlign: 'top' }}>
                {formSchema?.form?.columns?.heder09}
              </th>
              <th style={{ padding: 3, verticalAlign: 'top' }}>
                {formSchema?.form?.columns?.heder10}
              </th>
              <th style={{ padding: 3, verticalAlign: 'top' }}>
                {formSchema?.form?.columns?.heder11}
              </th>
              <th style={{ padding: 3, verticalAlign: 'top' }}>
                {formSchema?.form?.columns?.heder12}
              </th>
            </tr>

            {formSchema?.form?.values?.map((item, index, arr) => {
              // console.log('item', item)

              const projectSpan = getProjectRowSpan(arr, index)
              const sectionSpan = getSectionRowSpan(arr, index)

              const prev = arr[index - 1]

              const isNewSection = item.sectionNo !== null && prev?.sectionNo === null

              const cellStyle = {
                padding: 3,
                verticalAlign: 'top',
                borderTop: isNewSection ? '3px solid black' : '1px solid #999',
              }

              return (
                <tr key={index}>
                  {projectSpan > 0 && (
                    <td style={cellStyle} rowSpan={projectSpan}>
                      {item.projectCode}
                    </td>
                  )}

                  {sectionSpan > 0 && (
                    <td style={cellStyle} rowSpan={sectionSpan}>
                      {item.sectionNo}
                    </td>
                  )}

                  <td style={cellStyle}>{item.subSectionNo}</td>
                  <td style={cellStyle}>{item.evaluationTopic}</td>
                  <td style={cellStyle}>{item.evaluationPhase}</td>
                  <td style={cellStyle}>{item.componentType}</td>
                  <td style={cellStyle}>{item.weightPercent}</td>
                  <td style={cellStyle}>{item.score}</td>
                  <td style={cellStyle}>{item.calculatedScore}</td>
                  <td style={cellStyle}>{item.qualitativeDetail}</td>
                  <td style={cellStyle}>{item.teamReflection}</td>
                  <td style={cellStyle}>{item.observedChange}</td>
                </tr>
              )
            })}
          </table>
          <TablePagination
            lengthMenu={defaultLengthMenu}
            activePage={page || defaultPage}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total || 0} รายการ`}</>
            }}
            displayLength={displayLength || 5}
            total={totalSize}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />
        </div>
      </>
    </Panel>
  )
}
